import { useState, useEffect } from 'react';
import s from './Nav.module.css';

const LINKS = [
  { label: 'Skills',     href: '#skills'     },
  { label: 'Work',       href: '#projects'   },
  { label: 'Experience', href: '#experience' },
  { label: 'Contact',    href: '#contact'    },
];

const BREAKPOINT = 768;

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open,     setOpen]     = useState(false);
  const [mobile,   setMobile]   = useState(
    typeof window !== 'undefined' ? window.innerWidth <= BREAKPOINT : false
  );

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    const onResize = () => {
      const m = window.innerWidth <= BREAKPOINT;
      setMobile(m);
      if (!m) setOpen(false);
    };
    window.addEventListener('scroll', onScroll);
    window.addEventListener('resize', onResize);
    // run once to sync
    onScroll(); onResize();
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onResize);
    };
  }, []);

  const close = () => setOpen(false);

  return (
    <>
      <nav className={`${s.nav} ${scrolled ? s.scrolled : ''}`}>

        {/* Logo — always left */}
        <a href="#" className={s.logo}>Yosry Mlika</a>

        {/* Desktop centre links */}
        {!mobile && (
          <div className={s.links}>
            {LINKS.map(l => (
              <a key={l.label} href={l.href} className={s.link}>{l.label}</a>
            ))}
          </div>
        )}

        {/* Right side */}
        <div className={s.right}>
          {!mobile && (
            <a href="#contact" className={s.cta}>Hire Me</a>
          )}

          {/* Hamburger — mobile only, always on the right */}
          {mobile && (
            <button
              className={s.burger}
              onClick={() => setOpen(o => !o)}
              aria-label={open ? 'Close menu' : 'Open menu'}
              aria-expanded={open}
            >
              <span className={s.bar} style={{
                transform: open ? 'translateY(7px) rotate(45deg)' : 'none',
              }}/>
              <span className={s.bar} style={{ opacity: open ? 0 : 1 }}/>
              <span className={s.bar} style={{
                transform: open ? 'translateY(-7px) rotate(-45deg)' : 'none',
              }}/>
            </button>
          )}
        </div>
      </nav>

      {/* Drawer — only mount on mobile */}
      {mobile && (
        <div
          className={s.drawer}
          style={{
            transform:  open ? 'translateY(0)' : 'translateY(-108%)',
            visibility: open ? 'visible' : 'hidden',
            transition: `transform .32s cubic-bezier(.22,1,.36,1), visibility 0s ${open ? '0s' : '.32s'}`,
          }}
        >
          {LINKS.map(l => (
            <a key={l.label} href={l.href} className={s.dlink} onClick={close}>
              {l.label}
            </a>
          ))}
          <div className={s.drawerCta}>
            <a href="#contact" className={s.dcta} onClick={close}>Hire Me</a>
          </div>
        </div>
      )}
    </>
  );
}